import * as ActionTypes from "../../actions";
var invertirOnlinePriceRows = function invertirOnlinePriceRows() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_INVERTIRONLINEPRICES_SUCCESS:
      return action.response._embedded ? action.response._embedded.invertirOnlinePrices : [];
    default:
      return state;
  }
};
export default invertirOnlinePriceRows;